import MockAPI from './mock'
import HTTP_API from './http'

const useMockAPI = process.env.REACT_APP_ENV === 'development'

const API = useMockAPI ? MockAPI : HTTP_API

export default API
